function parseJsonResponse(res) {
  if (res.status === 404) {
    return null;
  }
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
  return res.json();
}

const fetchOpts = { credentials: 'include', cache: 'no-store' };

export default {
  getProblems() {
    return fetch('/api/v1/problems', fetchOpts)
      .then(parseJsonResponse)
      .catch((error) => {
        console.error('[GET PROBLEMS ERROR]:', error);
        return [];
      });
  },

  get(id) {
    const url = id ? `/api/v1/data/${id}` : `/api/v1/data`;
    return fetch(url, fetchOpts)
      .then(parseJsonResponse)
      .catch((error) => {
        console.error('[GET ERROR]:', error);
        return id ? null : [];
      });
  },
};
